module.exports = __webpack_public_path__ + "static/img/5_1.7958e1b7.jpg";